if(!window.URL) {
    window.URL = {}
	window.URL.createObjectURL = function () {
        return ''
    }
}


// WEBPACK FOOTER //
// ./src/components/common/urlPolyfill.js